import { bffServiceClient } from 'packages/request/clients';
import { getData } from '../../helpers/request';
import {
  ITimesheetParams,
  ITimesheetResult,
  ITimesheetExportData,
} from 'interfaces/timesheet';
import qs from 'qs';

const getTimesheet = (params: ITimesheetParams): Promise<ITimesheetResult> => {
  return bffServiceClient
    .get('/checkIn', {
      params: params,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    })
    .then(getData);
};

const exportTimesheet = (
  params: ITimesheetParams
): Promise<ITimesheetExportData> => {
  return bffServiceClient
    .get('/checkIn/export', {
      params,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    })
    .then(getData);
};

const rejectTimesheet = (id: number, reasonReject: string) => {
  return bffServiceClient
    .post('/checkIn', { id: id, reasonReject: reasonReject })
    .then(getData);
};

export default {
  getTimesheet,
  exportTimesheet,
  rejectTimesheet,
};
